<template>
  <div>
    <h2>{{ $t('views.medicalpersons.affiliations.detail.title') }}</h2>

    <entity-detail-table :entityKey="eParent.key" :entityId="eParent.id" />
  </div>
</template>

<script>
import EntityDetailTable from '@/components/entity/DetailTable'
import MixinEntityBase from '@/components/mixins/EntityBase'

export default {
  name: 'MedicalPersons.Affiliations.Detail',
  mixins: [MixinEntityBase],
  components: {
    EntityDetailTable
  },
  computed: {
    entity () {
      return this.$store.getters[`${this.eParent.key}/getEntity`](this.eParent.id) || null
    }
  },
  methods: {
    onApproveToggle () {
      this.$store.dispatch(`${this.eParent.key}/toogleApprove`, this.eParent.id)
    },
    onInput (controlValue) {
      /* do something with controlValue = { [propKey]: value } */
    },
    onChange (controlValue) {
      /* do something with controlValue = { [propKey]: value } */
    },
    onSave (entity) {
      this.$store.dispatch(`${this.eParent.key}/updateEntity`, entity)
    }
  }
}
</script>

<style lang="scss"></style>
